import { FC, useCallback } from 'react';
import { DateRadioPickerDayState, DateRadioPickerOption } from './dateRadioPicker.types';
import { merge } from '@/helpers/Utility';
import { DateRadioPickerDay, RosterBusyHeaderHeight, RosterBusyPickerHeight } from './DateRadioPickerDay';

interface DateRadioPickerProps {
  selectedValues: DateRadioPickerDayState[];
  setSelectedValues: (newValues: DateRadioPickerDayState[]) => void;
  options: DateRadioPickerOption[];
}

export const DateRadioPicker: FC<DateRadioPickerProps> = ({ selectedValues, setSelectedValues, options }) => {
  const onSelect = useCallback(
    (index: number) => (selectedOption?: DateRadioPickerOption) => {
      const stateCopy = [...selectedValues];
      const recordToUpdate = stateCopy[index];
      const newRecord: DateRadioPickerDayState = {
        date: recordToUpdate.date,
        option: selectedOption ? { ...selectedOption } : undefined
      };

      if (newRecord.option?.value === recordToUpdate.option?.value) {
        newRecord.option = undefined;
      }

      stateCopy.splice(index, 1, newRecord);
      setSelectedValues(stateCopy);
    },
    [selectedValues, options]
  );

  return (
    <div className="border">
      <div className={`flex w-full`}>
        <div className="flex flex-col text-center w-[400px] border-r">
          <div className={merge('border-b', RosterBusyHeaderHeight)} />
          {options.map(opt => (
            <p className={merge('border-b items-center justify-center flex', RosterBusyPickerHeight)}>{opt.name}</p>
          ))}
        </div>
        <div
          className={`overflow-x-auto flex 1 grid grid-cols-${selectedValues.length} w-min border-r`}
          style={{ gridTemplateColumns: `repeat(${selectedValues.length}, 70px)` }}
        >
          {selectedValues.map((day, index) => {
            return (
              <DateRadioPickerDay
                selectedOption={day.option}
                date={day.date}
                onSelect={onSelect(index)}
                options={options}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};
